export default index => {
  const swiperOptions = {
    loop: true,
    slidesPerView: 1,
    centeredSlides: true,
    autoplay: false,
    pagination: {
      el: `.js-swiper-pagenation.swiper-no${index}`,
      clickable: true,
    },
  }
  return new Swiper(
    `.js-productDetails-slider-container.swiper-no${index}`,
    swiperOptions
  )
}
